// extracted by mini-css-extract-plugin
export var printerCard = "_bn-1";
export var printerCardConfigured = "_bn-2";
export var printerCardError = "_bn-3";
export var printerCardsContainer = "_bn-0";
export var printerIcon = "_bn-8";
export var printerIconConfigured = "_bn-5";
export var printerIconContainer = "_bn-4";
export var printerIconError = "_bn-6";
export var printerIconUnconfigured = "_bn-7";
export var workstationsTableCard = "_bn-9";